import React, { useRef, useEffect, useState } from "react";
import "./video.css";

const VideoPlayer = ({ src }) => {
  const [isMuted, setIsMuted] = useState(true);
  const [muteIcon, setMuteIcon] = useState("https://cdn.icon-icons.com/icons2/1933/PNG/512/iconfinder-volume-mute-sound-speaker-audio-4593175_122269.png");
  const videoRef = useRef(null);

  useEffect(() => {
    const videoElement = videoRef.current;
    if (videoElement) {
      videoElement.muted = true; // Ensure video is muted initially
    }

    const handleUserInteraction = () => {
      if (videoElement) {
        videoElement.play().catch(error => {
          console.error("Error playing video:", error);
        });
      }
      window.removeEventListener('click', handleUserInteraction);
    };

    window.addEventListener('click', handleUserInteraction);

    return () => {
      window.removeEventListener('click', handleUserInteraction);
    };
  }, []);

  const toggleMute = () => {
    setIsMuted((prevMuted) => !prevMuted);
    setMuteIcon((prevIcon) =>
      prevIcon === "https://cdn.icon-icons.com/icons2/1933/PNG/512/iconfinder-volume-mute-sound-speaker-audio-4593175_122269.png"
        ? "https://cdn-icons-png.flaticon.com/512/2058/2058599.png"
        : "https://cdn.icon-icons.com/icons2/1933/PNG/512/iconfinder-volume-mute-sound-speaker-audio-4593175_122269.png"
    );
  };

  const enterFullScreen = () => {
    if (videoRef.current) {
      if (videoRef.current.requestFullscreen) {
        videoRef.current.requestFullscreen();
      } else if (videoRef.current.webkitRequestFullscreen) {
        // Safari
        videoRef.current.webkitRequestFullscreen();
      } else if (videoRef.current.msRequestFullscreen) {
        // IE11
        videoRef.current.msRequestFullscreen();
      } else if (videoRef.current.mozRequestFullScreen) {
        // Firefox
        videoRef.current.mozRequestFullScreen();
      }
    }
  };

  /* const changeSound = () =>{
    if (mute == "https://cdn.icon-icons.com/icons2/1933/PNG/512/iconfinder-volume-mute-sound-speaker-audio-4593175_122269.png"){
      unmuteVideo()
    }
    else{
      muteVideo();
    }
  } */

  return (
    <div className="video__container" >
      <video ref={videoRef} id="video"onClick={enterFullScreen}>
        <source src={src} type="video/mp4" />
      </video>
      <div className="eye">
        <img src={muteIcon}  onClick={toggleMute}/>
      </div>
    </div>
  );
};

export default VideoPlayer;
